export default __webpack_public_path__ + "media/mock/src/img/card_cvv_amex-44e4a5458b04bba85be86831b3314cfa.svg";